import $  from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import './styles.scss';
export default class ShareWidget{
	constructor(config,$ShareWidgets){
		this.getParentIconType = this.getParentIconType.bind(this);
		this.getIcon = this.getIcon.bind(this);
		let props ={};	
	   	    $ShareWidgets.each((index,el)=>{
	    	let $el = $(el);
	    	let shareItem = $el.data('configId');
	    	let shareItemIndex = window.shareItemsMap.indexOf(shareItem);
	    	if(shareItemIndex<0) return;
	   	 	let shareItemData = window.dataShareItem[shareItemIndex];
	    	props["icon-type"]= this.getParentIconType(shareItemData["config-id"],config).iconType;
	    	props["itemClassName"]= this.getParentIconType(shareItemData["config-id"],config).itemClassName;
	    	props["parent-icon"]= this.getParentIconType(shareItemData["config-id"],config).icon;
	    	props["icon-facebook"] = this.getIcon(shareItemData["facebook"]);
	    	props["icon-twitter"] = this.getIcon(shareItemData["twitter"]);
	    	props["icon-linkedin"] = this.getIcon(shareItemData["linkedin"]);
	    	props["icon-google"] = this.getIcon(shareItemData["google"]);
	    	props["icon-email"] = this.getIcon(shareItemData["email"]);
	    	props["config-id"] = shareItem;
	    	if(shareItem==='vertical-right'|| shareItem ==='vertical-left'|| shareItem==='horizon'){
	    		props['pIcon-show'] = false;
	    	}else{
	    		props["pIcon-show"] = true;

	    	}
	    	 ReactDOM.render(React.createElement(App,props),el);
	    	$(el).data('module','');
	    })
	}
	getParentIconType(ShareType,config){
		let parentIcon = {iconType:"",itemClassName:"",icon:""};
		if(ShareType === 'hover')
		{
            parentIcon.iconType = this.getParentIcon(config[1]["config-id"]);
            parentIcon.icon = this.getParentIcon(config[1]);
            parentIcon.itemClassName = 'groupSharing';
    	}
       	if(ShareType === 'email'){
       		  parentIcon.iconType = this.getParentIcon(config[0]["config-id"]);
       		  parentIcon.icon = this.getParentIcon(config[0]);
    		  parentIcon.itemClassName = 'groupEmail';
    	}
    	return parentIcon;
	}

	getParentIcon(iconData){
		if(typeof(iconData)==='undefined'){
			return "";

		}
		return iconData.icon && iconData.icon.length>0 ? iconData.icon : "default";
		}
	getIcon(iconData){
		if(typeof(iconData)==='undefined' || !iconData.isActive){
			return "";
		}
		return iconData.icon && iconData.icon.length>0 ? iconData.icon : "default";
	}
}
ShareWidget.selector = '[data-module="ShareWidget"]';
ShareWidget.init = (config,$ShareWidgets) => {
	$ShareWidgets = $ShareWidgets || $(ShareWidget.selector);
	window.dataShareItem = window.dataShareItem || config;
	window.shareItemsType = window.shareItemsType || [];
	window.shareItemsMap = window.dataShareItem.map((shareGroup)=>{
		return shareGroup["config-id"];
	})
	if($ShareWidgets.length>0){
		new ShareWidget(config,$ShareWidgets);
	}
}




// WEBPACK FOOTER //
// ./medscape_modules/share-widget/index.js